var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-skeleton-loader',_vm._b({attrs:{"type":"table-thead,table-tbody,table-tfoot"}},'v-skeleton-loader',_vm.attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }